import { useEffect, useState } from "react";
import { Typography, Row, Col, Input, Select, Alert, InputNumber } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const EditEmployee = ({ id }) => {
  const { MainResponse } = useSelector((state) => state);

  const navigate = useNavigate();

  const [employeeName, setEmployeeName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [oldCompanyName, setOldCompanyName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [oldDepartmentName, setOldDepartmentName] = useState("");
  const [positionName, setPositionName] = useState("");
  const [oldPositionName, setOldPositionName] = useState("");
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [employeePhone, setEmployeePhone] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const [showAlertIncorrectEmail, setShowAlertIncorrectEmail] = useState(false);
  const [showAlertForPass, setShowAlertForPass] = useState(false);
  const [showAlertForPasslength, setShowAlertForPasslength] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const adminId = JSON.parse(localStorage.getItem("user"))._id;

  useEffect(() => {
    getAEmployee();
  }, []);

  const getAEmployee = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-employee/${id}`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();

    setEmployeeName(result.employeeName);
    setCompanyName(result.companyName);
    setOldCompanyName(result.companyName);
    setPositionName(result.positionName);
    setOldPositionName(result.positionName);
    setDepartmentName(result.departmentName);
    setOldDepartmentName(result.departmentName);
    setEmployeeEmail(result.employeeEmail);
    setEmployeePhone(result.employeePhone);
  };

  const handleChangeCompany = (value) => {
    setCompanyName(value);
  };

  const handleChangeDepartment = (value) => {
    setDepartmentName(value);
  };

  const handleChangePosition = (value) => {
    setPositionName(value);
  };

  const prepareToSave = () => {
    if (isValidEmail(employeeEmail)) {
      if (password.length > 0) {
        if (
          employeeName.length > 0 &&
          companyName.length > 0 &&
          positionName.length > 0 &&
          departmentName.length > 0 &&
          employeeEmail.length > 0 &&
          employeePhone.length > 0 &&
          password.length > 0 &&
          repeatPassword.length > 0
        ) {
          checkPasswordLength();
          setShowAlert(false);
        } else {
          setShowAlert(true);
        }
      } else {
        updateEmployeeWithoutPassword();
      }
    } else {
      setShowAlertIncorrectEmail(true);
    }
  };

  const checkPasswordLength = () => {
    if (password.length > 5) {
      setShowAlertForPasslength(false);
      updateEmployee();
    } else {
      setShowAlertForPasslength(true);
    }
  };

  const updateEmployeeWithoutPassword = async () => {
    if (
      employeeName &&
      companyName &&
      positionName &&
      departmentName &&
      employeeEmail &&
      employeePhone
    ) {
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/employee-update/${id}`,
        {
          method: "put",
          body: JSON.stringify({
            employeeName,
            companyName,
            oldCompanyName,
            positionName,
            oldPositionName,
            departmentName,
            oldDepartmentName,
            employeeEmail,
            employeePhone,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(false);

        if (result._id === adminId) {
          localStorage.setItem("user", JSON.stringify(result));
        }
        navigate(-1);
      }
    } else {
      setShowAlert(true);
    }
  };

  const updateEmployee = async () => {
    if (password === repeatPassword) {
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/employee-update/${id}`,
        {
          method: "put",
          body: JSON.stringify({
            employeeName,
            companyName,
            oldCompanyName,
            positionName,
            oldPositionName,
            departmentName,
            oldDepartmentName,
            employeeEmail,
            employeePhone,
            password,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(false);
        if (result._id === adminId) {
          localStorage.setItem("user", JSON.stringify(result));
        }
        navigate(-1);
      }
    } else {
      setShowAlertForPass(true);
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <>
      {showAlertIncorrectEmail && (
        <Alert
          onClose={() => setShowAlertIncorrectEmail(false)}
          message="Diqqət!"
          description="E-poçt hesabında səhv var!"
          type="warning"
          showIcon
          closable
        />
      )}

      {showAlertForPasslength && (
        <Alert
          onClose={() => setShowAlertForPasslength(false)}
          message="Diqqət!"
          description="Şifrələr 5 simvoldan çox olmalıdır!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlertForPass && (
        <Alert
          onClose={() => setShowAlertForPass(false)}
          message="Diqqət!"
          description="Şifrələriniz eyni deyil!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}

      <Row className="add-row">
        <Col span={6}>
          <Typography.Text className="add-title">Ad və soyad</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={employeeName}
            onChange={(e) => setEmployeeName(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            size="large"
            value={companyName}
            onChange={handleChangeCompany}
            className="add-dropdown"
            options={MainResponse.allCompanyNames}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şöbə</Typography.Text>

          <Select
            size="large"
            value={departmentName}
            onChange={handleChangeDepartment}
            className="add-dropdown"
            options={MainResponse.allDepartmentNames}
          />
        </Col>

        <Col span={6}>
          <Typography.Text className="add-title">Vəzifə</Typography.Text>

          <Select
            size="large"
            value={positionName}
            onChange={handleChangePosition}
            className="add-dropdown"
            options={MainResponse.allPositionNames}
          />
        </Col>
      </Row>

      <Row className="add-row">
        <Col span={5}>
          <Typography.Text className="add-title">E-poçt</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={employeeEmail}
            onChange={(e) =>
              setEmployeeEmail(e.target.value.toLowerCase().trim())
            }
          />
        </Col>

        <Col span={5}>
          <Typography.Text className="add-title">Telefon</Typography.Text>
          <InputNumber
            className="add-input"
            size="large"
            onChange={(e) => setEmployeePhone(e)}
            value={employeePhone}
          />
        </Col>

        <Col span={5}>
          <Typography.Text className="add-title">Yeni şifrə</Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={5}>
          <Typography.Text className="add-title">
            Yeni şifrənin təkrarı
          </Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={2}>
          <button
            disabled={buttonDisable}
            onClick={prepareToSave}
            className="success-button"
          >
            Əlavə Et
          </button>
        </Col>
        <Col span={2}>
          <button
            className="cancel-button"
            onClick={() => {
              navigate(-1);
            }}
          >
            İmtina Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default EditEmployee;
